module.exports = __webpack_public_path__ + "img/CRDS-logo.a6e32a7f.png";